import type { ReactNode } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";
import Header from "./Header/Header";
import store from "store/store";
import { Provider } from "react-redux";
import { NavigationMenu, UnauthenticatedNavigationMenu } from "./Header/NavigationMenu";
import { usePersistentValue, useTitle } from "hooks";
import { localStorageKeys } from "config/app-config";

interface RootProps {
  isUnauthenticated?: boolean;
}

function Root({ isUnauthenticated = false }: Readonly<RootProps>): ReactNode {
  const [isNavMenuOpen, setIsNavMenuOpen] = usePersistentValue<boolean>(
    localStorageKeys.navigationMenu,
    true
  );
  useTitle();

  if (isUnauthenticated) {
    return (
      <>
        <Header isUnauthenticated isMenuOpen={isNavMenuOpen} setIsMenuOpen={setIsNavMenuOpen} />
        <Box sx={{ display: "flex", mb: 2 }}>
          <UnauthenticatedNavigationMenu isOpen={isNavMenuOpen} onOpen={setIsNavMenuOpen} />
          <Box component="main" sx={{ flexGrow: 1, width: "100%" }}>
            <Outlet />
          </Box>
        </Box>
      </>
    );
  }

  return (
    <Provider store={store}>
      <Header isMenuOpen={isNavMenuOpen} setIsMenuOpen={setIsNavMenuOpen} />
      <Box sx={{ display: "flex", mb: 2 }}>
        <NavigationMenu isOpen={isNavMenuOpen} onOpen={setIsNavMenuOpen} />
        <Box component="main" sx={{ flexGrow: 1, width: "100%" }}>
          <Outlet />
        </Box>
      </Box>
    </Provider>
  );
}

export default Root;
